import { render, staticRenderFns } from "./ProgramAdminDetails.vue?vue&type=template&id=5280b33e&lang=pug&"
import script from "./ProgramAdminDetails.vue?vue&type=script&lang=js&"
export * from "./ProgramAdminDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports